 import React, { useEffect, useState, useRef } from 'react';
 import { useTranslation } from 'react-i18next';
 import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);

    // Mouse following particles effect
    const heroSection = heroRef.current;
    if (!heroSection) return;

    const createParticle = (x, y) => {
      const particle = document.createElement('div');
      particle.className = 'mouse-particle';
      particle.style.left = x + 'px';
      particle.style.top = y + 'px';
      heroSection.appendChild(particle);

      setTimeout(() => {
        if (particle.parentNode) {
          particle.parentNode.removeChild(particle);
        }
      }, 1000);
    };

    const handleMouseMove = (e) => {
      const rect = heroSection.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Create particle every few pixels
      if (Math.random() < 0.1) {
        createParticle(x, y);
      }
    };

    heroSection.addEventListener('mousemove', handleMouseMove);

    return () => {
      heroSection.removeEventListener('mousemove', handleMouseMove);
      // Clean up any remaining particles
      const remainingParticles = heroSection.querySelectorAll('.mouse-particle');
      remainingParticles.forEach(particle => {
        if (particle.parentNode) {
          particle.parentNode.removeChild(particle);
        }
      });
    };
  }, []);

  const scrollToVision = () => {
    const visionSection = document.getElementById('vision');
    if (visionSection) {
      visionSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToFooter = () => {
    const footer = document.querySelector('footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <section ref={heroRef} id="hero" className={`hero section ${isVisible ? 'visible' : ''}`}>
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-logo">
            <div className="hero-logos-container">
              <div className="hero-eu-funding" onClick={scrollToFooter}>
                <span className="kliknij-text">Click</span>
                <img src="/EUDofinansowanie .png" alt="European Union Funding" className="hero-logo-right" />
              </div>
              <div className="title-logos-row">
                <img src="/IkonaCatRamka.png" alt="Firm Logo" className="hero-logo-frame" />
                <h1 className="hero-title-logo">{t('hero.title')}</h1>
                <img src="/IkonaCatRamka.png" alt="Firm Logo" className="hero-logo-frame" />
              </div>
            </div>
          </div>
          <p className="hero-subtitle fade-in-up" style={{ animationDelay: '0.3s' }}>
            {t('hero.subtitle')}
          </p>
          <p className="hero-description fade-in-up" style={{ animationDelay: '0.6s' }} dangerouslySetInnerHTML={{ __html: t('hero.description') }}>
          </p>
          <button
            className="btn hero-btn fade-in-up"
            style={{ animationDelay: '0.9s' }}
            onClick={scrollToVision}
          >
            {t('hero.btnExplore')}
          </button>
        </div>

        <div className="hero-visual">
          <div className="neon-grid">
            <div className="grid-line horizontal h1"></div>
            <div className="grid-line horizontal h2"></div>
            <div className="grid-line horizontal h3"></div>
            <div className="grid-line vertical v1"></div>
            <div className="grid-line vertical v2"></div>
            <div className="grid-line vertical v3"></div>
          </div>

          <div className="floating-elements">
            <div className="floating-element elem1 pulse">
              <span className="code-bracket">&#123;</span>
            </div>
            <div className="floating-element elem2 pulse">
              <span className="code-bracket">&#125;</span>
            </div>
            <div className="floating-element elem3">
              <div className="neon-circle"></div>
            </div>
            <div className="floating-element elem4">
              <div className="neon-circle small"></div>
            </div>
            <div className="floating-element elem5">
              <div className="neon-circle"></div>
            </div>
            <div className="floating-element elem6">
              <div className="neon-diamond"></div>
            </div>
            <div className="floating-element elem7">
              <div className="neon-square"></div>
            </div>
            <div className="floating-element elem8">
              <div className="neon-triangle"></div>
            </div>
          </div>
        </div>

        <div className="scroll-indicator" onClick={scrollToVision}>
          <div className="scroll-mouse">
            <div className="scroll-wheel"></div>
          </div>
          <p className="scroll-text">Scroll Down</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;